/**
 * StatsCheckpoint.
 *
 * @param {Object} params - Object parameter
 * @param {string} params.id - Unique identifier
 * @param {integer} params.attendee_count - number of attendees
 * @param {integer} params.scan_in - number of scan in
 * @param {integer} params.scan_out - number of scan out
 * @constructor
 */
export default class StatsCheckpoint {
	constructor({
		checkpoint_id,
		attendee_count,
		scan_pairing,
		scan_in,
		scan_out,
		inside_count,
		outside_count,
		expired_stats,
		last_update,
		organizer_id
	} = {}) {
		this._checkpoint_id = checkpoint_id;
		this._attendee_count = attendee_count;
		this._scan_pairing = scan_pairing;
		this._scan_in = scan_in;
		this._scan_out = scan_out;
		this._inside_count = inside_count;
		this._outside_count = outside_count;
		this._expired_data = expired_stats || false;
		this._last_update = last_update;
		this._organizerId = organizer_id;
	}

	checkpointId() {
		return this._checkpoint_id;
	}

	attendeeCount() {
		if (this._expired_data) {
			return null;
		}
		return this._attendee_count;
	}

	scanIn() {
		if (this._expired_data) {
			return null;
		}
		return this._scan_in;
	}

	hasScanIn() {
		return Boolean(this.scanIn());
	}

	scanOut() {
		if (this._expired_data) {
			return null;
		}
		return this._scan_out;
	}

	expiredData() {
		return this._expired_data;
	}

	getLastUpdate() {
		return this._last_update;
	}

	getAttendeePercent() {
		if (
			this._expired_data ||
			(this._attendee_count === null || this._scan_in === null)
		) {
			return null;
		}
		if (!this._attendee_count) {
			return 0;
		}
		return this.getPercent(this._scan_in);
	}

	scanPairing() {
		if (this._expired_data) {
			return null;
		}
		return this._scan_pairing;
	}

	getPercent(scanCount = 0) {
		return Math.round((scanCount * 100) / this._attendee_count) || 0;
	}

	getAverage() {
		const scanIn = this.scanIn();
		const attendees = this.attendeeCount();

		// If no scanIn and attendees are empty
		// Or if only scanIn are empty
		if ((scanIn === 0 && attendees === 0) || (scanIn === 0 && attendees)) {
			return 0;
		}

		const total = scanIn / attendees;

		if (isNaN(total) || total === Infinity) {
			return null;
		}

		return Math.round(total * 100);
	}

	hasAttendees() {
		return this.attendeeCount() > 0;
	}
	totalCompostedAttendees() {
		return (this._inside_count || 0) + (this._outside_count || 0);
	}
}
